import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import {
  feesCard,
  feesFooterSection
} from '../componentSections/detailsFeesComponents';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';
import { clientLogger } from '../../../lib/logger';
import { useFptiImpression } from '../../../lib/hooks';

const DetailsFees = ({
  componentContent = {},
  fptiImpression,
  handleClickFPTI,
  app = {}
}) => {
  const {
    subtitleLink,
    subtitle,
    title,
    fees,
    legalDisclaimer,
    style
  } = componentContent;
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: 'fees'
    });
  });
  if (!fees) {
    fireDetailsPageComponentFailureFpti({
      data: { fees },
      componentName: 'DetailsFees',
      fptiImpression
    });
    return null;
  }

  const parsedFees = parseData(fees);
  const showFeesSideSection = Boolean(title);
  let styleObject = {};

  if (style) {
    try {
      styleObject = JSON.parse(style);
    } catch (error) {
      clientLogger.warn(
        `Corrupt JSON in the style object ${style}, Error : ${error}`
      );
    }
  }

  return (
    <section id="details-fees" style={styleObject}>
      <div className="details-fees-header">
        <HeadingText level={2} >{title}</HeadingText>
        <h4
          onClick={e =>
            e.target.tagName === 'A' &&
            e.target.getAttribute('data-fptilinkname')
              ? handleClickFPTI(e.target.getAttribute('data-fptilinkname'))
              : {}
          }
          dangerouslySetInnerHTML={{ __html: subtitle }}
          role="presentation"
        />
      </div>
      <div className="details-fees-grid" ref={ref}>
        {feesCard(parsedFees, handleClickFPTI, app)}
      </div>
      {showFeesSideSection &&
        feesFooterSection({
          subtitleLink,
          handleClickFPTI,
          app,
          legalDisclaimer
        })}
    </section>
  );
};

DetailsFees.propTypes = {
  app: PropTypes.object,
  componentContent: PropTypes.object,
  cardTitle: PropTypes.string,
  cardFooterText: PropTypes.string,
  feeSideLinkText: PropTypes.string,
  feeSideSubtitle: PropTypes.string,
  feeSideTitle: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  feeSubtext: PropTypes.string,
  feeSideLinkUrl: PropTypes.string,
  fee: PropTypes.string,
  featureItem: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  feeSideFPTI: PropTypes.string
};

export default DetailsFees;
